var exports = {
  "Qs": "GiftAcceptModal.module__content___aEp1QV",
  "O8": "GiftAcceptModal.module__loadingContent___aEp1QV",
  "Nr": "GiftAcceptModal.module__card___aEp1QV",
  "$2": "GiftAcceptModal.module__cardGrid___aEp1QV",
  "kJ": "GiftAcceptModal.module__iconCircle___aEp1QV",
  "SP": "GiftAcceptModal.module__iconCircleActive___aEp1QV",
  "PP": "GiftAcceptModal.module__iconCircleInactive___aEp1QV",
  "_O": "GiftAcceptModal.module__iconCircleDisabled___aEp1QV",
  "Kk": "GiftAcceptModal.module__icon___aEp1QV",
  "m5": "GiftAcceptModal.module__iconError___aEp1QV",
  "Ux": "GiftAcceptModal.module__cardContent___aEp1QV",
  "DD": "GiftAcceptModal.module__title___aEp1QV",
  "jn": "GiftAcceptModal.module__titlePrimary___aEp1QV",
  "xP": "GiftAcceptModal.module__titleTertiary___aEp1QV",
  "S3": "GiftAcceptModal.module__titleDanger___aEp1QV",
  "VA": "GiftAcceptModal.module__subtitle___aEp1QV",
  "BK": "GiftAcceptModal.module__helpText___aEp1QV",
  "qr": "GiftAcceptModal.module__footer___aEp1QV",
};

module.exports = exports;
